import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { api } from './services/api';
import { analytics } from './services/analytics';
import Header from './components/Header';
import PlaylistList from './pages/PlaylistList';
import AddPlaylist from './pages/AddPlaylist';
import EditPlaylist from './pages/EditPlaylist';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

function AppContent() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated && auth.sessionToken) {
      api.setSessionToken(auth.sessionToken);
      analytics.setDeviceKey(auth.deviceKey);
      analytics.track('manager_session_start', {
        action_source: 'qr_scan'
      });
    }
  }, [auth.isAuthenticated, auth.sessionToken, auth.deviceKey]);

  // Show loading while checking auth
  if (auth.isLoading) {
    return <LoadingSpinner message="Authenticating..." />;
  }

  // Show error if auth failed
  if (auth.error) {
    return (
      <div className="app">
        <div className="auth-error">
          <svg className="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <h1>Access Denied</h1>
          <p>{auth.error}</p>
          <p className="hint">Please scan the QR code on your TV to access the playlist manager.</p>
        </div>
      </div>
    );
  }

  // Show access denied if not authenticated
  if (!auth.isAuthenticated) {
    return (
      <div className="app">
        <div className="auth-error">
          <svg className="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <h1>Authentication Required</h1>
          <p>Please scan the QR code on your TV to access the playlist manager.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<PlaylistList />} />
          <Route path="/add" element={<AddPlaylist />} />
          <Route path="/edit/:id" element={<EditPlaylist />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  // Use basename from env (default to '/' for Railway, '/manage' for embedded in backend)
  const basename = process.env.REACT_APP_BASENAME || '/';

  return (
    <AuthProvider>
      <BrowserRouter basename={basename}>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
